import styled from "styled-components";

import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const BannerWrapper = styled.div`
    background-color: ${colorsPalettes.blue[100]};
    height: 114px;
    padding: 32px;
    box-shadow: 0 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    margin: 0 40px;
`;

const LeftWrapper = styled.span`
    margin-top: -26px;
`;

const RightWrapper = styled(FlexColumn)`
    justify-content: space-between;
    height: 100%;
`;

const Title = styled.div`
    ${mixins.setFont({
        $size: 24,
        $weight: 500,
        $color: colorsPalettes.carbon[500],
        $family: "DM Sans",
    })};
    margin-bottom: 10px;
`;

const SubTitle = styled.div`
    ${mixins.setFont({ $size: 16, $weight: 500, $color: colorsPalettes.carbon[300] })};
`;

const StyledIconButton = styled(IconButton)`
    align-self: flex-start;
`;

const i18n = i18nFilter();

export const AfterTrialBanner = () => {
    const getCTAButton = () => {
        return (
            <StyledIconButton
                type="trial"
                style={{ lineHeight: "normal" }}
                onClick={() => {
                    allTrackers.dispatchTrackEvent("Internal Link", "click", "Hook PRO/homepage/banner");
                    goToPackagesPage();
                }}
                iconName="sparkles"
            >
                {i18n("trial_banner.button.go.to.packages.text")}
            </StyledIconButton>
        );
    };

    return (
        <BannerWrapper>
            <RightWrapper>
                <div>
                    <Title>{i18n("aftertrial.homepage.banner.title")}</Title>
                    <SubTitle>{i18n("aftertrial.homepage.banner.sub.title")}</SubTitle>
                </div>
                {getCTAButton()}
            </RightWrapper>
            <LeftWrapper>
                <img
                    alt=""
                    src={AssetsService.assetUrl("/images/after-trial-banner-illustration.svg")}
                />
            </LeftWrapper>
        </BannerWrapper>
    );
};
